import React from "react";
import PropTypes from "prop-types";

import Section from "../common/Section";
import RelativeLink from "../common/RelativeLink";
import Form from "../common/Form";
import Row from "../common/Row";
import Button from "../common/Button";
import Fieldset from "../common/Fieldset";
import FieldsetSubHeader from "../common/FieldsetSubHeader";
import DownloadUploadFiles from "../common/DownloadUploadFiles";
import * as types from "../../constants/ComponentConstants";
import redirector from "../../util/redirector.js";
import moment from "moment";
import * as domainConstants from "../../constants/DomainConstants";

const DossierForm = (props) => {

	const {
		voortgangsrapporten,
		rapportUrl,
		documentUrl,
		pdfUrl,
		documenten,
		dossier,
		needToRedirect,
		dossierStatus
	} = props;

	const dossierNaam = props.dossierNaam ? props.dossierNaam : null;

	const pdfIcon = pdfUrl ? <a className="minimal" href={pdfUrl}><i className="fi flaticon-pdf"/></a> :
		null;

	const rapporten = voortgangsrapporten && voortgangsrapporten.length > 0
		? voortgangsrapporten.map((rapport, i) => {
			const url = rapportUrl ? rapportUrl + rapport.id : "";
			const pdfUrl = documentUrl + "voortgangsrapport/" + rapport.id + "/pdf";
			const pdfRapportIcon = rapport.pdfBeschikbaar ? <a className="minimal" href={pdfUrl}><i className="fi flaticon-pdf" /></a> : null;

			const row = (
				<Row key={i}>
					<div className="o-col-4"><RelativeLink className="minimal" to={url}>{rapport.naam}</RelativeLink></div>
					<div className="o-col-1">{pdfRapportIcon}</div>
					<div className="o-col-7"/>
				</Row>
			);

			return (row);
		})
		: null;

	function goToNiewRapport() {
		redirector.goTo(props.nieuwRapportUrl);
	}

	let rapporteringButton;
	if (props.rapporteringMogelijk && props.deadlineVoortgangsrapport) {
		moment.locale('nl');
		const maand = moment(props.deadlineVoortgangsrapport).format('MMMM YYYY');
		rapporteringButton = <Button text={"Nieuw rapport " + maand} onClick={goToNiewRapport} />;
	} else {
		rapporteringButton = null;
	}

	function getFilesForDossierComponent(component) {
		if (documenten) {
			const folder = documenten.find(x => x.name === component);
			if (folder) return folder.files;
		}
		return [];
	}

	let OpenDossierForm;
	if (needToRedirect && dossier.dossierUitVorigeJaargang && dossier.redenVanStatus.toString() === domainConstants.REDEN_VAN_STATUS_IN_AANMAAK) {
		OpenDossierForm = (
			<Form
				name="dossier"
				isNotRequired>
				<Fieldset>
					<Row>
						<FieldsetSubHeader>
							Dossier "{dossierNaam}" is een aanvraagdossier uit één van de vorige aanvraagrondes.<br />
							Dit dossier kan niet meer geconsulteerd worden via het portaal.
						</FieldsetSubHeader>
					</Row>
					<Row>
						<FieldsetSubHeader>
							Jouw ingevoerde gegevens kan je nog wel bekijken in de pdf van je aanvraagdossier {pdfIcon}
						</FieldsetSubHeader>
					</Row>
				</Fieldset>
			</Form>
		);
	} else {
		OpenDossierForm = (
			<Form
				name="dossier"
				title="Startpagina"
				isNotRequired>
				<Fieldset>
					<Row>
						{needToRedirect ?
							<div className="o-col-4"><a className="minimal" href={props.editPageUrl}>{dossierNaam}</a></div> :
							<div className="o-col-4"><RelativeLink className="minimal" to={props.editPageUrl}>{dossierNaam}</RelativeLink></div>}
						<div className="o-col-1">{pdfIcon}</div>
						<div className="o-col-7"/>
					</Row>
					<Row>
						<div className="o-col-4">{dossierStatus}</div>
					</Row>
				</Fieldset>
			</Form>
		);
	}

	return (
		<div>
			<Section
				title="Open dossier"
				color={types.COLOR_BLUE}>
				{OpenDossierForm}
			</Section>
			{dossier.algemeneStatus === domainConstants.ALGEMENE_STATUS_GESELECTEERD ?
				<Section
					title="Individueel ministerieel besluit"
					color={types.COLOR_TURQUOISE_DARK}>
					<Fieldset>
						<DownloadUploadFiles
							title="Ministerieel besluit"
							color={types.COLOR_TURQUOISE_DARK}
							tab={domainConstants.DocumentTab.MijnDossier}
							component={domainConstants.ComponentName.MinisterieelBesluit}
							dossierId={dossier.dossierId}
							size={6}
							center
							files={getFilesForDossierComponent(domainConstants.ComponentName.MinisterieelBesluit)}
							downloadOnly
						/>

					</Fieldset>
				</Section>
				: null}
			{(props.rapporteringMogelijk) || (!props.rapporteringMogelijk && voortgangsrapporten && voortgangsrapporten.length > 0) ?
				<Section
					title="Voortgangsrapporten"
					color={types.COLOR_ORANGE}>
					<Form
						name="voortgangsrapporten"
						title="Rapporten"
						isNotRequired>
						<Fieldset>
							{rapporten}
						</Fieldset>
						<Fieldset>
							{rapporteringButton}
						</Fieldset>
					</Form>
				</Section>
				:
				""
			}

		</div>
	);
};

DossierForm.propTypes = {
	dossierNaam: PropTypes.string.isRequired,
	dossierStatus: PropTypes.string.isRequired,
	editPageUrl: PropTypes.string,
	pdfUrl: PropTypes.string,
	voortgangsrapporten: PropTypes.array,
	rapporteringMogelijk: PropTypes.bool,
	deadlineVoortgangsrapport: PropTypes.string,
	nieuwRapportUrl: PropTypes.string,
	rapportUrl: PropTypes.string,
	documentUrl: PropTypes.string,
	documenten: PropTypes.array,
	dossier: PropTypes.object,
	needToRedirect: PropTypes.bool
};

export default DossierForm;